// extracted by mini-css-extract-plugin
export default {"display4":"Pricing_display4__PtxhG"};